import { render, staticRenderFns } from "./PollutionList.vue?vue&type=template&id=f110aa4c&scoped=true&"
import script from "./PollutionList.vue?vue&type=script&lang=js&"
export * from "./PollutionList.vue?vue&type=script&lang=js&"
import style0 from "./PollutionList.vue?vue&type=style&index=0&id=f110aa4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f110aa4c",
  null
  
)

export default component.exports